import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=dcdc786e&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=dcdc786e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdc786e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageSnapshotsTableHeader: require('/usr/src/motec/components/page/snapshots/TableHeader.vue').default,PageSnapshotsCard: require('/usr/src/motec/components/page/snapshots/Card.vue').default})
